import { Link } from 'react-router'
import { Container, MeshTexture } from '@/components/site/primitives'
import { Button } from '@/components/ui/button'
import { usePageMeta } from '@/components/layout/site-layout'

export default function NotFoundPage() {
  usePageMeta('Page not found')

  return (
    <section className="bg-ink relative flex min-h-[80svh] items-center overflow-hidden pt-[calc(var(--header-h)+2rem)]">
      <MeshTexture opacity={0.06} />
      <Container className="relative text-center">
        <p className="display text-blood-deep text-[clamp(6rem,22vw,16rem)] leading-none">404</p>
        <h1 className="condensed text-bone -mt-4 text-2xl font-bold tracking-[0.08em] md:text-4xl">
          Off the pitch
        </h1>
        <p className="text-bone-dim mx-auto mt-5 max-w-md leading-relaxed">
          That page does not exist — it may have been moved or unpublished.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <Button asChild>
            <Link to="/">Back home</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/matches">See the fixtures</Link>
          </Button>
        </div>
      </Container>
    </section>
  )
}
